module.exports = __webpack_public_path__ + "img/远程人工喊话系统V1.0.cc0e37ec.jpg";